import { render, staticRenderFns } from "./IntegrationsSection.vue?vue&type=template&id=5bec9905"
import script from "./IntegrationsSection.vue?vue&type=script&lang=js"
export * from "./IntegrationsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports